import { S3 } from "./config";

// Function to upload a file to S3
async function uploadFileToS3(
  file: File,
  bucketName: string,
  key: string
): Promise<string> {
  return new Promise((resolve, reject) => {
    const params = {
      Bucket: "outss-assets",
      Key: bucketName + `/` + key,
      Body: file,
      ACL: "public-read",
    };

    S3.upload(params, (err: Error, data: AWS.S3.ManagedUpload.SendData) => {
      if (err) {
        console.error("Error uploading file to S3:", err);
        reject(err);
        return;
      }
      resolve(data.Location);
    });
  });
}

export default uploadFileToS3;
